import {
    Box, Typography, Tooltip, IconButton,
    Table, TableHead, TableBody, TableRow, TableCell, styled,
} from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import { OptionGroupType } from 'src/constants';

const StyledTable = styled(Table)({
    tableLayout: 'fixed',
});

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    borderBottom: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(2),
}));

const StyledTableHeaderCell = styled(TableCell)(({ theme }) => ({
    borderBottom: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(2),
    fontWeight: 'bold',
    backgroundColor: theme.palette.common.white,
}));

interface OptionGroupsListProps {
    type: OptionGroupType;
    options: Record<string, Models.IngestConfigApi.ForcedRankings.PartialProductSpec>;
    onEdit: (id: string) => void;
    onDelete: (type: OptionGroupType, id: string) => void;
}

export const OptionGroupsList = ({
    type,
    options,
    onEdit,
    onDelete,
}: OptionGroupsListProps): JSX.Element => (
    <StyledTable stickyHeader>
        <TableHead>
            <TableRow>
                <StyledTableHeaderCell>Group</StyledTableHeaderCell>
                <StyledTableHeaderCell align="right">Actions</StyledTableHeaderCell>
            </TableRow>
        </TableHead>
        <TableBody>
            {Object.entries(options ?? {}).length === 0 ? (
                <TableRow>
                    <StyledTableCell colSpan={2}>No option groups defined</StyledTableCell>
                </TableRow>
            ) : (
                Object.entries(options)
                    .sort(([, a], [, b]) => a.name.localeCompare(b.name))
                    .map(([id, spec]) => (
                        <TableRow
                            hover
                            key={id}
                            sx={{ cursor: 'pointer' }}
                            onClick={(): void => onEdit(id)}
                        >
                            <StyledTableCell>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Tooltip
                                        placement="right"
                                        title={(
                                            <Typography style={{ whiteSpace: 'pre-line' }} variant="body2">
                                                {Object.entries(spec.values).map(([key, value]) => `${key}: ${value}`).join('\n')}
                                            </Typography>
                                        )}
                                    >
                                        <Typography variant="body1">{spec.name}</Typography>
                                    </Tooltip>
                                </Box>
                            </StyledTableCell>
                            <StyledTableCell align="right">
                                <IconButton
                                    onClick={(e): void => {
                                        e.stopPropagation();
                                        onEdit(id);
                                    }}
                                >
                                    <Edit />
                                </IconButton>
                                <IconButton
                                    onClick={(e): void => {
                                        e.stopPropagation();
                                        onDelete(type, id);
                                    }}
                                >
                                    <Delete color="error" />
                                </IconButton>
                            </StyledTableCell>
                        </TableRow>
                    ))
            )}
        </TableBody>
    </StyledTable>
);
